import React, { useRef, useState } from "react";
import "./CustomVideoPlayer.scss";
import { Icon } from "witmeg-ui-system";

const CustomVideoPlayer = ({ src }) => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const togglePlay = () => {
        if (!videoRef.current) return;
        if (isPlaying) {
            videoRef.current.pause();
        } else {
            videoRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    return (
        <div className="custom-video-player">
            <video ref={videoRef} src={src} className="video-element"
                onClick={togglePlay}
                style={{
                    height: "350px",
                    objectFit: 'cover',
                    width: "382px",
                    maxHeight: "350px",
                    maxWidth: "382px",
                    minWidth: "382px",

                }}
                muted={true} />

            {!isPlaying && <button className="custom-play-btn" onClick={togglePlay}>
                {!isPlaying ? <Icon name="play"
                    color="white" /> : ""}
            </button>}
        </div>
    );
};

export default CustomVideoPlayer;
